import { render, staticRenderFns } from "./SingleLineDataTable.vue?vue&type=template&id=23b6922b&scoped=true&"
import script from "./SingleLineDataTable.vue?vue&type=script&lang=js&"
export * from "./SingleLineDataTable.vue?vue&type=script&lang=js&"
import style0 from "./SingleLineDataTable.vue?vue&type=style&index=0&id=23b6922b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b6922b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VTooltip})
